module.exports = __webpack_public_path__ + "img/nt-bottom.8455ccf6.png";